var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsString, IsUUID } from 'class-validator';
import { UserIcd10FullSizeDto } from '../../user/dto/user-icd10.full-size.dto.js';
import { AnamnesisFullSizeDto } from './anamnesis.full-size.dto.js';
export class Icd10FullSizeDto {
    id;
    code;
    text;
    anamneses;
    userIcd10s;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], Icd10FullSizeDto.prototype, "id", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], Icd10FullSizeDto.prototype, "code", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], Icd10FullSizeDto.prototype, "text", void 0);
__decorate([
    IsArray(),
    Type(() => AnamnesisFullSizeDto),
    __metadata("design:type", Array)
], Icd10FullSizeDto.prototype, "anamneses", void 0);
__decorate([
    IsArray(),
    Exclude(),
    Type(() => UserIcd10FullSizeDto),
    __metadata("design:type", Array)
], Icd10FullSizeDto.prototype, "userIcd10s", void 0);
//# sourceMappingURL=icd10.full-size.dto.js.map